<div class="messages-container">
  @if (participantMessages.userId) {
    <app-user-badge [userId]="participantMessages.userId"></app-user-badge>
  }
  <div class="messages" (appDomChange)="onDomChange($event)">
    @for (message of participantMessages.messages; track message; let i = $index) {
      <div
        [id]="'msg-' + message.id"
        class="message-bubble"
        [ngClass]="participantMessages.name || message.removed ? 'other' : 'me'"
        [class.requires-upgrade]="message.requiresUpgrade"
        snInViewport
        [inViewportOptions]="inViewportOptions"
      (inViewportChange)="
        onInViewPortChange(!!participantMessages.name, message.id, message.unread, message.removed, $event)
      ">
        <div class="message-content">
          @if (i === 0) {
            <div class="author">{{ participantMessages.name }}</div>
          }
          <div class="box">
            <div class="inner-box">
              <app-dynamic-content
                class="chat-message"
                [ngClass]="message.removed ? 'removed' : ''"
              [content]="message.content"></app-dynamic-content>
              <div class="timestamp">
                <span>{{ message.timestamp }}</span>
              </div>
            </div>
          </div>
        </div>
        @if (message.requiresUpgrade) {
          <div class="requires-upgrade">
            <div>
              This message contains content that your current app version can't display. Tap below to upgrade to the latest
              version.
            </div>
            <ion-button class="ph-btn-white" (click)="upgradeClicked.emit()">UPGRADE</ion-button>
          </div>
        }
      </div>
    }
  </div>
</div>
